


import MouseIcon from '@material-ui/icons/MouseTwoTone';
import KeyIcon from '@material-ui/icons/KeyboardTwoTone';
import RegularIcon from '@material-ui/icons/CallMadeTwoTone';
import BrowserIcon from '@material-ui/icons/LanguageTwoTone';
// import IfIcon from '@mui/icons-material/HelpOutline';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
// import LoopIcon from '@material-ui/icons/LoopTwoTone';
// import TaskIcon from '@mui/icons-material/List';
import { faRobot } from '@fortawesome/free-solid-svg-icons'
import { faList } from '@fortawesome/free-solid-svg-icons'
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons'
import FileIcon from '@material-ui/icons/DescriptionTwoTone';

import ListIcon from '@mui/icons-material/List';


import RESTIcon from '@material-ui/icons/LaunchTwoTone';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import EmailIcon from '@material-ui/icons/EmailTwoTone';

export default function mapIcon(nodeType){
  const designerIconStyle = {
    backgroundImage:'linear-gradient(to bottom, grey, royalblue)', padding:'5px', color:'white', borderRadius:'25px', marginLeft:'10px', marginRight:'10px'
}

  switch (nodeType) {
    case 'input': return  < PlayCircleFilledWhiteIcon fontSize='small' style={designerIconStyle} draggable={false}/>

    case 'MouseNode': return  <MouseIcon fontSize='small' style={designerIconStyle} draggable={false}/>

    case 'KeyNode': return  <KeyIcon fontSize='small' style={designerIconStyle} draggable={false}/>

    case 'BrowserNode': return  <BrowserIcon fontSize='small' style={designerIconStyle} draggable={false}/>

    case 'IfNode': return  <FontAwesomeIcon icon={faQuestionCircle} style={designerIconStyle} size='1x'/>

    case 'LoopNode': return <FontAwesomeIcon icon={faSyncAlt} style={designerIconStyle} size='1x'/>

    // case 'BizNode': return <FontAwesomeIcon icon={faList} style={designerIconStyle} size='1x'/>
    case 'BizNode': return <ListIcon fontSize='small' style={designerIconStyle} draggable={false}/>
    
    case 'BotNode': return <FontAwesomeIcon icon={faRobot} style={designerIconStyle} size='1x'/>

    case 'FileNode': return <FileIcon fontSize='small' style={designerIconStyle} draggable={false}/>

    case 'RESTNode': return <RESTIcon fontSize='small' style={designerIconStyle} draggable={false}/>

    case 'EmailNode': return <EmailIcon fontSize='small' style={designerIconStyle} draggable={false}/>

    case 'RegularNode': return <RegularIcon fontSize='small' style={designerIconStyle} draggable={false}/>


    default: return <RegularIcon fontSize='small' style={designerIconStyle} draggable={false}/>
  }

}